import { render, staticRenderFns } from "./ministerMap.vue?vue&type=template&id=3f9df008&scoped=true&"
import script from "./ministerMap.vue?vue&type=script&lang=js&"
export * from "./ministerMap.vue?vue&type=script&lang=js&"
import style0 from "./ministerMap.vue?vue&type=style&index=0&id=3f9df008&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9df008",
  null
  
)

export default component.exports